import React, { useEffect, useState } from 'react';
import { InstitutionsTable, InstitutionsHeader } from 'components';
import { getInstitutions } from '../services/institutions';
import { useTranslation } from 'react-i18next';
import { ListProvider } from 'contexts';

export const Institutions = () => {
	const [loading, setLoading] = useState(false);
	const [institutions, setInstitutions] = useState([]);
	const { t } = useTranslation();

	useEffect(() => {
		fetch();
	}, []);

	const fetch = async () => {
		try {
			setLoading(true);
			const { data } = await getInstitutions();
			setInstitutions(data);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<ListProvider
			lastPageName='lastPageInstitutions'
			fetch={getInstitutions}
		>
			<InstitutionsHeader fetchInstitutions={fetch} />
			<InstitutionsTable />
		</ListProvider>
	);
};
